import { useState } from "react";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";

interface IContractMetrics {
  nextInstallment: string;
  profit: string;
  receivedInstallments: string;
  files: string;
}

export const UseGetContractMetrics = () => {
  const { handleGetAlert } = useLayoutMainContext();

  const [isLoading, setIsLoading] = useState(false);

  const [dataMetrics, setDataMetrics] = useState<IContractMetrics>({
    nextInstallment: "",
    profit: "",
    receivedInstallments: "",
    files: "",
  });

  const handleGet = (id: string) => {
    setIsLoading(true);

    api
      .get(`/contracts/metrics/${id}`)
      .then((result) => {
        setDataMetrics(result.data);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      );
  };

  return { isLoading, handleGet, dataMetrics };
};
